const partnerPaymentsGenerationSectionResources = {
    partnerPaymentWarningMessageFormat: 'Partner Payments have already been generated. Are you sure you want to re-generate them?',
    partnerPaymentConfirmationMessageFormat: 'Please specify fees that need to be added to {0} Partner Payments.'
};
export default partnerPaymentsGenerationSectionResources;
